import styled from 'styled-components';
import ST from 'components/Input/SelectableTile';

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const CarInformationContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.xl};
  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: ${({ theme }) => theme.spacing.xl};

  text-align: start;
  &:hover {
    cursor: pointer;
  }
`;

export const ViewMoreContainer = styled.div`
  width: 170px;
  background: ${({ theme }) => theme.background.primary};
  color: ${({ theme }) => theme.text.inverse};
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.xl};

  &:hover {
    background: ${({ theme }) => theme.background.primaryHover};
  }
  &:active {
    background: ${({ theme }) => theme.background.primaryActive};
  }
`;

export const GeneralInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm};
  text-align: start;
`;

export const Image = styled.img`
  object-fit: cover;
  object-position: center;
  width: 120px;
  aspect-ratio: 1;
  height: 100%;
`;

export const SelectableTile = styled(ST)`
  width: 300px;
  height: 100%;
  min-height: 110px;
  padding: 0;

  ${({ theme, selected }) =>
    theme.innerAlignBorder(
      theme.border.xs,
      selected ? theme.border.strong : theme.border.subtle,
      false,
    )}

  &:not(:disabled):active {
    ${({ theme }) => theme.innerAlignBorder(theme.border.xs, theme.border.strong, false)}
  }
`;

export const ViewMoreTile = styled(ST)`
  width: 150px;
  padding: 0;
  height: 100%;
`;
